import { call, all, put, takeLatest } from "redux-saga/effects";

import {
  updateChangeRequestSuccess,
  updateChangeRequestFail,
} from "../actionCreators/ChangeRequest";
import { doPut } from "../utils/request";

function* updateChangeRequest({ obj }) {
  try {
    const response = yield doPut(`/changerequest`, obj);
    yield put(updateChangeRequestSuccess(response.data));
  } catch (err) {
    yield put(
      updateChangeRequestFail(err.response.data.message || err.message)
    );
    yield put(updateChangeRequestFail());
  }
}

export default function* watcher() {
  yield all([takeLatest("UPDATE_CHANGE_REQUEST", updateChangeRequest)]);
}
